import { IDataTypeData, IDrawer } from '../PublicationContent';
import { dataTypeContentModifier } from './DataTypes';
import { threeColumnContentModifier } from './ThreeColumn';

interface contentModifierParams {
  setDrawer: React.Dispatch<React.SetStateAction<IDrawer>>;
  push: (location: any, state?: any) => void;
  node: HTMLDivElement;
  setDataTypeData: React.Dispatch<React.SetStateAction<IDataTypeData>>;
  openResourceModal: (slug: string) => void;
}

export const contentModifier = ({
  node,
  setDrawer,
  push,
  setDataTypeData,
  openResourceModal,
}: contentModifierParams) => {
  if (!node) return;

  node.querySelectorAll('iframe').forEach((iframe) => {
    iframe.parentElement?.classList.add('iframe-wrapper');
  });

  threeColumnContentModifier(node);
  dataTypeContentModifier({ setDrawer, node, push, setDataTypeData, openResourceModal });
};
